import { render } from "./ProgramComputeMetrics.vue?vue&type=template&id=1e8d1d4c&scoped=true"
import script from "./ProgramComputeMetrics.vue?vue&type=script&lang=js"
export * from "./ProgramComputeMetrics.vue?vue&type=script&lang=js"

import "./ProgramComputeMetrics.vue?vue&type=style&index=0&id=1e8d1d4c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8d1d4c"],['__file',"resources/js/components/analytics/ProgramComputeMetrics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e8d1d4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e8d1d4c', __exports__)) {
    api.reload('1e8d1d4c', __exports__)
  }
  
  module.hot.accept("./ProgramComputeMetrics.vue?vue&type=template&id=1e8d1d4c&scoped=true", () => {
    api.rerender('1e8d1d4c', render)
  })

}


export default __exports__